export const ConceptType = {
    contextual: {
        label: 'Contextual',
        value: 1,
        key: 'contextual'
    },
    quality: {
        label: 'Quality',
        value: 2,
        key: 'quality'
    },
    safety: {
        label: 'Safety',
        value: 3,
        key: 'safety'
    },
    bi: {
        label: 'BI',
        value: 7,
        key: 'bi'
    }
}